import CandidateTestAnswer from '@/orm/models/Candidate/CandidateTestAnswer';
import BaseModel from '../BaseModel';
import Test from '../Test/Test';

export default class CandidateTest extends BaseModel {
  static entity = 'candidateTest';

  static fields() {
    return {
      id: this.attr(null),
      test: this.hasOne(Test, 'candidateId'),
      testAnswers: this.hasMany(CandidateTestAnswer, 'candidateId'),
      testResult: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      fetchCandidateTest(id) {
        return this.get(`candidates/${id}/test`);
      },
    },
  }
}
